export default function boundsFromCoords(coordinates) {
    const lonArray = [] 
    const latArray = []

    coordinates.map(coord => {
        lonArray.push(coord[0])
        latArray.push(coord[1])
    })

    const lonArrayMin = Math.min(...lonArray)
    const lonArrayMax = Math.max(...lonArray)
    const latArrayMin = Math.min(...latArray)
    const latArrayMax = Math.max(...latArray)
    
    return [ 
        [lonArrayMin, latArrayMin], 
        [lonArrayMax, latArrayMax]
    ]
}